module.exports = __webpack_public_path__ + "static/media/shapes_10.2d3ab6c4.svg";